/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserBaseOut } from '../models/UserBaseOut';
import type { UserBasicDetailsOut } from '../models/UserBasicDetailsOut';
import type { UserCreate } from '../models/UserCreate';
import type { UserProfileDataOut } from '../models/UserProfileDataOut';
import type { UserProfileUpdate } from '../models/UserProfileUpdate';
import type { UserUpdateByUser } from '../models/UserUpdateByUser';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * Ping Users
     * @returns any Successful Response
     * @throws ApiError
     */
    public static pingUsersUsersPingGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/ping',
        });
    }
    /**
     * Get Profile
     * @returns UserBaseOut Successful Response
     * @throws ApiError
     */
    public static getProfileUsersMeGet(): CancelablePromise<UserBaseOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/me',
        });
    }
    /**
     * Get User Basic Data
     * @returns UserBasicDetailsOut Successful Response
     * @throws ApiError
     */
    public static getUserBasicDataUsersMeBasicGet(): CancelablePromise<UserBasicDetailsOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/me/basic',
        });
    }
    /**
     * Update User Context
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateUserContextUsersMeContextPut(
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/users/me/context',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update My Profile
     * @param requestBody
     * @returns UserProfileDataOut Successful Response
     * @throws ApiError
     */
    public static updateMyProfileUsersMeProfilePut(
        requestBody: UserProfileUpdate,
    ): CancelablePromise<UserProfileDataOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/users/me/profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Register User
     * @param requestBody
     * @returns UserBaseOut Successful Response
     * @throws ApiError
     */
    public static registerUserUsersPost(
        requestBody: UserCreate,
    ): CancelablePromise<UserBaseOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get User
     * @param userId
     * @returns UserBaseOut Successful Response
     * @throws ApiError
     */
    public static getUserUsersUserIdGet(
        userId: number,
    ): CancelablePromise<UserBaseOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Admin Update User
     * @param userId
     * @param requestBody
     * @returns UserBaseOut Successful Response
     * @throws ApiError
     */
    public static adminUpdateUserUsersUserIdPut(
        userId: number,
        requestBody: UserUpdateByUser,
    ): CancelablePromise<UserBaseOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/users/{user_id}',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete User
     * @param userId
     * @returns void
     * @throws ApiError
     */
    public static deleteUserUsersUserIdDelete(
        userId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/users/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Users By Client
     * @param clientId
     * @returns UserBaseOut Successful Response
     * @throws ApiError
     */
    public static listUsersByClientUsersClientClientIdGet(
        clientId: number,
    ): CancelablePromise<Array<UserBaseOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/client/{client_id}',
            path: {
                'client_id': clientId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Users
     * @param skip
     * @param limit
     * @returns UserBaseOut Successful Response
     * @throws ApiError
     */
    public static listUsersUsersGet(
        skip?: number,
        limit: number = 100,
    ): CancelablePromise<Array<UserBaseOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users',
            query: {
                'skip': skip,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
